module.exports = __webpack_public_path__ + "static/media/logo-mark-negative.28371261.svg";